export function clockMinutes (time) {
  if (!time) return NaN
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}

export function isShiftTimeOrderValid (clockInTime, clockOutTime) {
  const clockIn = clockMinutes(clockInTime)
  const clockOut = clockMinutes(clockOutTime)
  return Number.isFinite(clockIn) && Number.isFinite(clockOut) && clockIn < clockOut
}

export function isRestRangeWithinShift (timeRange, clockInTime, clockOutTime) {
  if (!Array.isArray(timeRange) || timeRange.length !== 2 ||
      !isShiftTimeOrderValid(clockInTime, clockOutTime)) {
    return false
  }
  const shiftStart = clockMinutes(clockInTime)
  const shiftEnd = clockMinutes(clockOutTime)
  const restStart = clockMinutes(timeRange[0])
  const restEnd = clockMinutes(timeRange[1])
  return restStart >= shiftStart && restEnd <= shiftEnd && restStart < restEnd
}

export function isClockOutWindowWithinSameDay (clockOutTime, clockOutAfterDuration) {
  const clockOut = clockMinutes(clockOutTime)
  const clockOutAfter = clockMinutes(clockOutAfterDuration)
  return Number.isFinite(clockOut) && Number.isFinite(clockOutAfter) &&
    clockOutAfter >= 0 && clockOut + clockOutAfter < 24 * 60
}

export function clockOutAfterSelectableRange (clockOutTime) {
  const clockOut = clockMinutes(clockOutTime)
  const defaultMaxDuration = 12 * 60
  const maxDuration = Number.isFinite(clockOut)
    ? Math.max(0, Math.min(defaultMaxDuration, 24 * 60 - clockOut - 1))
    : defaultMaxDuration
  const hours = Math.floor(maxDuration / 60).toString().padStart(2, '0')
  const minutes = (maxDuration % 60).toString().padStart(2, '0')
  return `00:00:00 - ${hours}:${minutes}:00`
}

export function validAbsenceThresholdOrder (halfDayThreshold, fullDayThreshold) {
  return Number(halfDayThreshold) < Number(fullDayThreshold)
}
